<app-list-document *ngIf="mode === 'list'" [contractId]="contractId" (parentReload)="parentReload()" [isOwnerParty]="isOwnerParty"
[documents]="documents" (editDocument)="editDocument($event)" (parentChangeToEdit)="parentChangeToEdit()"
(detailDocument)="detailDocument($event)"></app-list-document>

<app-add-document #addDocument *ngIf="mode === 'add'"
[documents]="documents" [contractId]="contractId" (parentReload)="parentReload()"></app-add-document>

<app-edit-document #editingDocument *ngIf="mode === 'edit'"
[documents]="documents" [documentDetail]="documentDetail" [contractId]="contractId" (parentReload)="parentReload()"></app-edit-document>